import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TakeawayServices } from '../../services';

/**
 * Generated class for the TpvTicketSelectedListTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
    selector: 'page-takeaway-order-info-ticket-print',
    templateUrl: 'takeaway-order-info-ticket-print.html',
})
export class TakeawayOrderInfoTicketPrintPage {
    @Input() selected_list: any;
    footer: any;
    header: any;
    list_tax: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public takeawayServices: TakeawayServices) {


    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selected_list) {
            this.list_tax = this.globals.showIvaProducts(this.selected_list);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order/takeaway-order-info-ticket-print/takeaway-order-info-ticket-print.ts